import CustomCodeBlock from "../../../../src/components/mdxComponents/customCodeBlock.js";
import * as React from 'react';
export default {
  CustomCodeBlock,
  React
};